export default "__VITE_ASSET__WTKiX1iE__"